import Vue from 'vue'

import {
  Breadcrumb,
  BreadcrumbItem,
  Tabs,
  TabPane,
  Pagination,
  Input,
  Button,
  Select,
  Radio,
  RadioGroup,
  RadioButton,
  Form,
  FormItem,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Option,
  Message,
  Popover,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Loading,
  Dialog,
  Upload,
  DatePicker,
  MessageBox,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Tooltip,
  Switch,
  TimelineItem,
  Timeline,
  Card,
  Table,
  TableColumn
} from 'element-ui'

export const message = (...args) => {
  if (!process.server) {
    Message(...args)
  }
}

export default (() => {
  Vue.use(Breadcrumb)
  Vue.use(BreadcrumbItem)
  Vue.use(Tabs)
  Vue.use(TabPane)
  Vue.use(Pagination)
  Vue.use(Input)
  Vue.use(Button)
  Vue.use(Select)
  Vue.use(Radio)
  Vue.use(RadioGroup)
  Vue.use(RadioButton)
  Vue.use(Form)
  Vue.use(FormItem)
  Vue.use(Checkbox)
  Vue.use(CheckboxButton)
  Vue.use(CheckboxGroup)
  Vue.use(Option)
  Vue.use(Dropdown)
  Vue.use(DropdownMenu)
  Vue.use(DropdownItem)
  Vue.use(Loading.directive)
  Vue.use(Popover)
  Vue.use(Dialog)
  Vue.use(Upload)
  Vue.use(DatePicker)
  Vue.use(Menu)
  Vue.use(Submenu)
  Vue.use(MenuItem)
  Vue.use(MenuItemGroup)
  Vue.use(Tooltip)
  Vue.use(Switch)
  Vue.use(Timeline)
  Vue.use(TimelineItem)
  Vue.use(Card)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.prototype.$msgbox = MessageBox
  Vue.prototype.$alert = MessageBox.alert
  Vue.prototype.$confirm = MessageBox.confirm
  // Vue.prototype.$msg = Message
  Vue.prototype.$msg = function (msg, type) {
    Message({
      message: msg,
      type: type || ''
    })
  }
})()



// WEBPACK FOOTER //
// ./src/config/element-ui.js